import ClubActionLogEntry from '../dto/ClubActionLogEntry';
import Error from '../model/Error';
import axios from 'axios';

export default class ClubActionLogRepository {
    static findAll(clubId, filter) {
        const params = {
            filter,
        };
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/action-log-entries`, { params })
                .then(response => resolve(response.data.data.map(data => ClubActionLogEntry.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static findEventTypes(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/action-log-entries/event-types`)
                .then(response => resolve(response.data.data))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }
}
